(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/game-launcher-wrapper.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/game-launcher-wrapper.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PlayFooter = svs.ticket_gifts.redeem.components.PlayFooter;
const useCustomEvents = svs.ticket_gifts.redeem.components.useCustomEvents;
const BubbleWinMessage = svs.tur.bubbleWinMessage.components.BubbleWinMessage;
const {
  GameLauncherLeia,
  GameWrapper,
  TopBar,
  LoaderTicket,
  TicketIdPopper
} = svs.ticketgames.ticketUtility.components;
const {
  resizeFromFullscreen,
  resizeFromTicketInfo,
  useDefaultEventsLeiaFactory,
  useScratchDefaultEventsLeiaFactory,
  showDialog,
  tracking
} = svs.ticketgames.ticketUtility.utils;
const {
  useEffect,
  useState,
  useCallback,
  useReducer,
  useMemo
} = React;
const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_GAME_REF':
      return _objectSpread(_objectSpread({}, state), {}, {
        gameRef: action.payload
      });
    case 'SET_BET_ID':
      return _objectSpread(_objectSpread({}, state), {}, {
        betId: action.payload
      });
    default:
      return state;
  }
};
const GameLauncherWrapper = _ref => {
  var _ticketInfo$skins;
  let {
    history,
    onClose,
    skinId,
    ticketInfo,
    wagerId,
    match,
    nextVoucher,
    voucherCode,
    isPurchaseDisabled
  } = _ref;
  const [fullScreenMargin, setFullScreenMargin] = useState(false);
  const [wrapperSize, setWrapperSize] = useState({});
  const isFullScreenGame = ticketInfo.width === 0 && ticketInfo.height === 0;
  const betId = wagerId && parseInt(wagerId, 10);
  const [state, dispatch] = useReducer(reducer, {
    ticketInfo,
    betId,
    isFullScreenGame,
    voucherCode
  });
  const contextValue = useMemo(() => _objectSpread(_objectSpread({}, state), {}, {
    dispatch
  }), [state, dispatch]);
  useDefaultEventsLeiaFactory({
    ticketInfo,
    wagerId,
    onClose,
    voucherCode,
    isPurchaseDisabled
  });
  const {
    onPlayAgain
  } = useCustomEvents({
    ticketInfo,
    isFullScreenGame,
    onClose,
    history,
    match,
    nextVoucher,
    dispatch
  });
  const {
    isLoading,
    gameResult,
    shouldShowPlayAgainFooter,
    shouldShowBubbleWinMessage,
    soundStatus
  } = useScratchDefaultEventsLeiaFactory({
    ticketInfo,
    isFullScreenGame,
    onClose,
    onPlayAgain,
    hasNextVoucher: Boolean(nextVoucher)
  });
  const onResizeFunc = isFullScreenGame ? resizeFromFullscreen : resizeFromTicketInfo;
  useEffect(() => {
    svs.ticket_gifts.redeem.components.util.hideFooter();
    if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      const extraParams = {
        amount: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.price,
        product: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.name,
        branding: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.icon
      };
      svs.components.customer_login.login({
        returnNewCustomer: true,
        extraParams
      });
    }
  }, []);
  const onResize = useCallback(container => {
    const size = onResizeFunc(container, ticketInfo);
    if (isFullScreenGame) {
      setFullScreenMargin(size === null || size === void 0 ? void 0 : size.isMinHeight);
    } else {
      setWrapperSize(size);
    }
  }, []);
  const bubbleWinOptions = _objectSpread({
    demo: false,
    product: ticketInfo.type
  }, gameResult);
  const topBarTrackingLabel = tracking.createTopBarTrackingLabel({
    location: 'lös-in-voucher',
    gameCode: ticketInfo.type
  });
  const wrapperStyles = isFullScreenGame && fullScreenMargin ? {
    padding: '24px'
  } : _objectSpread(_objectSpread({}, wrapperSize), {}, {
    margin: 'auto'
  });
  const gameSpecificParameters = {
    voucherId: voucherCode,
    skinId: skinId ? skinId : 1
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "js-game-launcher-wrapper ".concat(gameResult ? 'game-complete ' : '').concat(isFullScreenGame ? '' : "padding-top-2")
  }, shouldShowBubbleWinMessage && !isFullScreenGame && React.createElement("div", {
    className: "qa-win-message-container game-header relative"
  }, React.createElement(BubbleWinMessage, {
    options: bubbleWinOptions
  })), React.createElement(GameWrapper, {
    className: "".concat(isFullScreenGame ? '' : 'ticket-shadow'),
    context: contextValue,
    styles: wrapperStyles
  }, React.createElement(TopBar, {
    isSoundOn: soundStatus,
    onClose: () => {
      var _gameResult$amount;
      showDialog({
        type: 'close',
        onClose,
        trackingData: {
          label: topBarTrackingLabel,
          value: (_gameResult$amount = gameResult === null || gameResult === void 0 ? void 0 : gameResult.amount) !== null && _gameResult$amount !== void 0 ? _gameResult$amount : -1
        }
      });
    },
    onSoundClick: () => {
      svs.ticketgames.falconBridge.falcon.instance.notifierProxy.notifySoundStatus(!soundStatus);
    },
    trackingLabel: topBarTrackingLabel
  }), React.createElement(GameLauncherLeia, {
    className: "relative",
    gameSpecificParameters: gameSpecificParameters,
    onResize: onResize
  }, !isLoading && React.createElement(TicketIdPopper, null), isLoading && React.createElement(LoaderTicket, {
    image: !isFullScreenGame && ((_ticketInfo$skins = ticketInfo.skins[skinId - 1]) === null || _ticketInfo$skins === void 0 ? void 0 : _ticketInfo$skins.image)
  })))), shouldShowPlayAgainFooter && React.createElement(PlayFooter, {
    hasMoreVouchers: nextVoucher,
    onClick: onPlayAgain,
    ticketInfo: ticketInfo
  }));
};
setGlobal('svs.ticket_gifts.redeem.components.GameLauncherWrapper', GameLauncherWrapper);

 })(window);